import React from 'react';
import { X, ArrowRight } from 'lucide-react';
export function PainPoints() {
  const pains = ['Improvisás clases constantemente', 'Perdés horas pensando qué enseñar', 'No sabés cómo estructurar una clase clara', 'Tus alumnos se aburren o abandonan', 'Tenés conocimiento pero no un sistema', 'Repetís contenido sin progresión', 'Te sentís saturado preparando clases', 'No podés escalar porque todo depende de vos'];
  return <section className="py-12 md:py-20 italian-cream border-y border-slate-200" data-id="element-200">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-201">
        <div className="text-center mb-8 md:mb-12" data-id="element-202">
          <p className="text-xs md:text-sm font-bold tracking-widest text-red-600 uppercase mb-2" data-id="element-203">
            Hablemos en serio
          </p>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-slate-900" data-id="element-204">
            Esto es para vos si…
          </h2>
        </div>

        <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl border border-slate-100 p-5 md:p-12 mb-8 md:mb-12" data-id="element-205">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-206">
            {pains.map((pain, idx) => <div key={idx} className="flex items-start gap-3 md:gap-4" data-id="element-207">
                <div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-red-100 text-red-500 flex items-center justify-center mt-0.5" data-id="element-208">
                  <X className="w-3 h-3 md:w-4 md:h-4 font-bold" strokeWidth={3} data-id="element-209" />
                </div>
                <p className="text-sm md:text-lg text-slate-700 font-medium" data-id="element-210">
                  {pain}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-211">
          <p className="text-lg md:text-2xl font-bold text-slate-900 mb-6 md:mb-8" data-id="element-212">
            Si te identificás con al menos una, este sistema es para vos.
          </p>
          <a href="#compra" className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white text-base md:text-lg font-bold py-3.5 md:py-4 px-6 md:px-8 rounded-xl shadow-lg shadow-emerald-500/30 transition-all hover:scale-105" data-id="element-213">
            QUIERO DEJAR DE IMPROVISAR
            <ArrowRight className="w-5 h-5" data-id="element-214" />
          </a>
        </div>
      </div>
    </section>;
}